import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import DownloadSection from './components/DownloadSection';
import ArticleRecommendSection from './components/ArticleRecommendSection';
import FAQSection from './components/FAQSection';

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '蘑菇视频',
  url: 'https://www.mogushipin.com',
  description: '蘑菇视频是一款备受用户喜爱的短视频娱乐平台，提供海量高清视频内容、流畅播放体验与丰富创作工具。',
  sameAs: [
    'https://weibo.com/mogushipin',
    'https://www.zhihu.com/org/mogushipin',
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'support@mogushipin.com',
    availableLanguage: ['Chinese'],
  },
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="蘑菇视频app官方下载与使用指南 - 短视频娱乐平台推荐"
        description="蘑菇视频app是一款备受用户喜爱的短视频娱乐平台，提供海量高清视频内容、流畅播放体验与丰富创作工具。详细介绍蘑菇视频app的核心功能、下载安装方法、使用技巧及常见问题解答，帮助新老用户快速上手，畅享优质视频内容。"
        keywords="蘑菇视频app,蘑菇视频app下载,蘑菇视频app官方版,蘑菇视频app安卓下载,蘑菇视频app怎么用,蘑菇视频app最新版本,短视频娱乐平台推荐"
        canonicalUrl="/"
      />
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <Navbar />
      <main>
        <HeroSection />
        <FeatureSection />
        <DownloadSection />
        <ArticleRecommendSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}